import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {Body} from '../typography/body';

type Props = {
    title: string;
    subtitle?: string;
    cta?: React.ReactNode;
};

export function EmptyStateMarketing(props: Props) {
    return (
        <div className='background-offwhite full-width full-height flex flex-dir-col align-center justify-center'>
            <div className='mb-32'>
                <StackLegacy spacing={8} alignCenter={true}>
                    <Body isBold={true}>{props.title}</Body>
                    <Body color='light'>{props.subtitle}</Body>
                </StackLegacy>
            </div>
            {props.cta}
        </div>
    );
}
